export default "__VITE_ASSET__Cdo4Yhyp__"